import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var auth = function auth(_ref) {
  var config = _ref.config,
    beforeAuthMiddleware = _ref.beforeAuthMiddleware,
    afterAuthMiddleware = _ref.afterAuthMiddleware,
    onLoad = _ref.onLoad;
  var storagePrefix = config.storagePrefix ? config.storagePrefix : '';
  var beforeRouteEnter = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
      var toQuery, token, aurl;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            toQuery = to.query || {}; // 授权前中间件
            if (!beforeAuthMiddleware) {
              _context.next = 4;
              break;
            }
            _context.next = 4;
            return beforeAuthMiddleware({
              query: toQuery
            });
          case 4:
            // 判断是否授权回来了。
            if (toQuery.token) {
              // 设置用户信息
              setWechatInfo(toQuery, _extends({}, config, {
                storagePrefix: storagePrefix
              }));
            }

            // 判断token是否需要授权。
            token = localStorage.getItem(storagePrefix + "token");
            if (token) {
              _context.next = 10;
              break;
            }
            localStorage.setItem(storagePrefix + "rurel", window.location.href);
            window.location.replace(config.oauth());
            return _context.abrupt("return", false);
          case 10:
            // 强制刷新页面。（因为如果页面上带着code去后台请求的话。会出现2个code都返回了）
            aurl = localStorage.getItem(storagePrefix + "rurel");
            if (!aurl) {
              _context.next = 15;
              break;
            }
            localStorage.setItem(storagePrefix + "rurel", '');
            window.location.replace(aurl);
            return _context.abrupt("return");
          case 15:
            if (!afterAuthMiddleware) {
              _context.next = 18;
              break;
            }
            _context.next = 18;
            return afterAuthMiddleware({
              query: toQuery
            });
          case 18:
            onLoad && onLoad();
            next();
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function beforeRouteEnter(_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
  return beforeRouteEnter;
};

// 配置授权回来的用户信息
var setWechatInfo = function setWechatInfo(query, config) {
  var openid = query.openid,
    unionid = query.unionid,
    token = query.token,
    nickname = query.nickname,
    headimgurl = query.headimgurl,
    city = query.city,
    language = query.language,
    province = query.province,
    sex = query.sex,
    subscribe = query.subscribe,
    country = query.country;
  var storagePrefix = config.storagePrefix;
  localStorage.setItem(storagePrefix + "openid", openid);
  localStorage.setItem(storagePrefix + "unionid", unionid);
  localStorage.setItem(storagePrefix + "token", token);
  localStorage.setItem(storagePrefix + "nickname", nickname);
  localStorage.setItem(storagePrefix + "headimgurl", headimgurl);
  localStorage.setItem(storagePrefix + "city", city);
  localStorage.setItem(storagePrefix + "language", language);
  localStorage.setItem(storagePrefix + "province", province);
  localStorage.setItem(storagePrefix + "sex", sex);
  localStorage.setItem(storagePrefix + "subscribe", subscribe);
  localStorage.setItem(storagePrefix + "country", country);
};
export default auth;